import React from "react";
import './featuring.css';

function Featuring() {
    return (
        <div className="feature">
            <p>Featuring : Digital Twinning and Machine Learning in Vibration</p>
        </div>
    )
}

export default Featuring;